import { useContext, useEffect, useState } from 'react';
import styles from './HastaPublica.module.scss';
import { BrDivider, BrSelect } from '@govbr-ds/react-components';
import { ICrumb } from '../../interfaces/ICrumb';
import { useNavigate } from 'react-router-dom';
import { declaracaoHastaPublicaInicial, DiefCfemContext } from '../../contexts/DiefCfemContext';
import TituloSection from '../../components/tituloSection/tituloSection';
import HastaPublicaTab from './components/hastaPublicaTab/hastaPublicaTab';
import CustomLoading from '../../components/customLoading/customLoading';
import { getAnoDeclaracao } from '../../utils/anoMesDeclaracao';

function HastaPublica() {
  const anoAtual = new Date().getFullYear();
  const [ano, setAno] = useState(anoAtual.toString());
  const navigate = useNavigate();

  const context = useContext(DiefCfemContext);

  const onAnoChange = (valor: string) => {
    setAno(valor);
    sessionStorage.setItem('anoDeclaracao', valor);
  };

  useEffect(() => {
    const crumbs: ICrumb[] = [
      {
        isHome: true,
        label: 'home',
        onClick: () => {
          navigate('/');
        },
      },
      {
        active: true,
        label: 'Arrematação em Hasta Pública',
      },
    ];
    context?.setCrumbs(crumbs);
    sessionStorage.setItem('anoDeclaracao', anoAtual.toString());
    sessionStorage.setItem('mesDeclaracao', '-1');
    context?.setDeclaracaoHastaPublica(declaracaoHastaPublicaInicial);

    const isPessoaNaoCadastrada = sessionStorage.getItem('isPessoaNaoCadastrada') === 'true';
    if (isPessoaNaoCadastrada) {
      navigate('/');
    }
  }, []);

  return (
    <>
      <BrDivider />
      <TituloSection type='hasta-publica' />
      <div className={styles.container}>
        <h4 className={styles.title}>Lista de Declarações</h4>
        <div className={styles.yearSelect}>
          <p className={styles.year}>Ano</p>
          <BrSelect
            className={styles.select}
            placeholder='Selecione...'
            value={ano}
            onChange={(valor: string) => onAnoChange(valor)}
            options={getAnoDeclaracao()}
            aria-autocomplete='none'
          />
        </div>
        <div className={styles.table}>
          <HastaPublicaTab year={ano} />
        </div>
      </div>
    </>
  );
}

export default HastaPublica;
